<template>
    <div>
        <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
        >
          <a-form-model  ref="dynamicValidateForm" :model="dynamicValidateForm" >
            <p><span>服务类型：</span>{{form.name}}</p>
            <span class="tit">价格</span>
            <div class=" " :key="domain.key" v-for="(domain, index) in dynamicValidateForm.domains">
              <a-form-model-item
                  :prop="'domains.' + index + '.quota'"
                  :rules="{ required: true, message: '请填写数量', trigger: 'blur', }" style="display: inline-block;width: 100px"
              >
                <a-input-number min="1" v-model="domain.quota" placeholder="数量" :precision="0" max="99999" @input="(e)=>{domain.quota=parseInt(e.replace(/[^\d]/g,''))||''}" />
              </a-form-model-item>
              <span style="position: relative;top: 5px;margin: 0 10px">{{form.quota_unit}}/</span>
              <a-form-model-item  :prop="'domains.' + index + '.price'"
                                 :rules="{ required: true, message: '请填写价格', trigger: 'blur', }" style="display: inline-block;width: 100px">
                <a-input-number min="1" :precision="0" v-model="domain.price" placeholder="价格" max="99999" @input="(e)=>{domain.price=parseInt(e.replace(/[^\d]/g,''))||''}"/>
              </a-form-model-item>

              <span style="position: relative;top: 5px;margin: 0 10px">元</span>
              <a-checkbox @change='changeCheck(index)' :checked='domain.is_default==1?true:false' style="position: relative;top: 5px; "> 是否默认 </a-checkbox>
              <a-icon
                  v-if="dynamicValidateForm.domains.length > 1"
                  class="dynamic-delete-button"
                  type="minus-circle-o"
                  :disabled="dynamicValidateForm.domains.length === 1"
                  @click="removeDomain(domain)"
                  style="position: relative;top: 5px; "
              />
            </div>
            <a-form-model-item v-bind="formItemLayoutWithOutLabel">
              <a-button type="dashed" style="width: 60%" @click="addDomain">
                <a-icon type="plus"/>
               添加
              </a-button>
            </a-form-model-item>
          </a-form-model>
            <div class="drawer-btn">
                <a-button type="primary" @click="onSubmit('dynamicValidateForm')" :style="{ marginRight: '8px' }">确定</a-button>
                <a-button @click="onClose">取消</a-button>
            </div>
        </a-drawer>
    </div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import API from "../api";
    export default {
        name: "filialeForm",
        props: ["visible","title","editId"],
        data() {
            return {
                drawerConfig,
                form:{   },
              dynamicValidateForm: {
                domains: [{
                  quota: '',
                  price:"",
                  id:"",
                  is_default:"0",
                  key: Date.now(),
                }],
              },
                formErr: {
                    team_name:"",
                    kf_name:"",
                    qq:""
                },
                // rules: {
                //     team_name: [
                //         {required: true, message: "请输入分公司/团队 ",},
                //         {whitespace: true,message: "请输入分公司/团队 "
                //     }, {
                //         validator: (rule, value, callback) => {
                //             validator(rule, value, callback, this.formErr.team_name)
                //         }, trigger: "blur"
                //     }],
                //     qq: [
                //         {required: true, message: "请输入QQ",},
                //         {whitespace: true,message: "请输入QQ"
                //     }, {
                //         validator: (rule, value, callback) => {
                //             validator(rule, value, callback, this.formErr.qq)
                //         }, trigger: "blur"
                //     }],
                // },
                layout: {
                    labelCol: {span: 6},
                    wrapperCol: {span: 14},
                },
            };
        },

        watch:{
            editId: function (a, b) {
                if (a != "") {
                    API.administrator.OPEN_EDIT(a).then(res => {
                        let val = res.data.data.info
                        this.form = val
                      this.dynamicValidateForm.domains=res.data.data.info.service_type_spec
                    })
                } else {
                    this.form.id = ''
                }
            }
        },
        methods: {
          changeCheck(index){
            let THAT=this
            let arrs=this.dynamicValidateForm.domains[index]

            this.dynamicValidateForm.domains.map((item,indexs)=>{
              let arr=this.dynamicValidateForm.domains[indexs]
              arr.is_default=0
              if(index!=indexs){
                console.log(indexs)
                this.$set(this.dynamicValidateForm.domains,indexs,arr)
              }

            })
                if(arrs.is_default==1){
                  arrs.is_default=0
                  THAT.$set(this.dynamicValidateForm.domains,index,arrs)
                }else{
                   arrs.is_default=1
                  THAT.$set(this.dynamicValidateForm.domains,index,arrs)
                }


          },
          removeDomain(item) {
            let index = this.dynamicValidateForm.domains.indexOf(item);
           if(this.dynamicValidateForm.domains[index].is_default==1) {
             this.$message.destroy()
             this.$message.error('默认选项不能删除');
             return
           }
            if (index !== -1) {
              this.dynamicValidateForm.domains.splice(index, 1);
            }
          },
          addDomain() {
            if( this.dynamicValidateForm.domains.length>=10){
              this.$message.destroy()
              this.$message.error('最多可添加10个');
              return
            }
            this.dynamicValidateForm.domains.push({
              quota: '',
              price:"",
              id:"",
              is_default:"0",
              key: Date.now(),
            });
          },
            onClose() {
                this.$emit("changVisible", false);
                this.$refs.ruleForm.resetFields();
              this.form={   }
                  this.dynamicValidateForm= {
                domains: [{
                  quota: '',
                  price:"",
                  id:"",
                  is_default:"0",
                  key: Date.now(),
                }]
              }
                this.formErr={
                    team_name:"",
                    kf_name:"",
                    qq:"",
                }
            },
            onSubmit(formName) {
                let _this = this;
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        submitForm(API.administrator.SUBMIT_EDIT, {id:_this.form.id,rule:_this.dynamicValidateForm.domains}).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            formMaxLength(len,item){
                this.formErr[item]=''
                if(this.form[item].length>len){
                    this.form[item] = this.form[item].substring(0,len)
                }
            },
            onChange(status){
                if(status == 1){
                    this.form.status = 0
                }else{
                    this.form.status = 1
                }

            }

        },
    }
</script>

<style scoped>
.tit::before {
  display: inline-block;
  margin-right: 4px;
  color: #f5222d;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: '*';
}
</style>
